import { HyperLinkControl } from "@/Common/Components/Buttons/HyperLinkControl";
import { CommunicationsUIState, CommunicationsUIStateInbox } from "@/Common/Models/UI/Enums";
import { CommunicationsHelper } from "../Helpers/CommunicationsHelper";
import { CommunicationsTab_OptimizedV2State } from "./CommunicationsTab_OptimizedV2";

interface ICommunicationsTreeControl_OptimizedV2Props {
    model: CommunicationsTab_OptimizedV2State;

    messageCreateClick: () => void;
    messageSearchClick: (inboxType: CommunicationsUIStateInbox) => void;

    taskCreateClick: () => void;
    taskSearchClick: (inboxType: CommunicationsUIStateInbox) => void;

    recallSearchClick: () => void;
    recallCreateClick: () => void;

    externalCommunicationCreateClick: () => void;
    externalCommunicationSearchClick: (inboxType: CommunicationsUIStateInbox) => void;

    portalCommunicationCreateClick: () => void;
    portalCommunicationSearchClick: (inboxType: CommunicationsUIStateInbox) => void;

    recallsCount: number;
    messagesCount: number;
    tasksCount: number;
    externalMessagesCount: number;
    portalCommunicationsUnreadCount: number;
    portalCommunicationsFlaggedCount: number;

    selectedUiState: CommunicationsUIState;
    selectedInbox: CommunicationsUIStateInbox;
}

class CommunicationsTreeControl_OptimizedV2 extends React.Component<ICommunicationsTreeControl_OptimizedV2Props, null> {
    public render(): JSX.Element {
        const recallUnderlined =
            this.props.selectedUiState === CommunicationsUIState.RecallsSearch
            || this.props.selectedUiState === CommunicationsUIState.RecallsView
            || this.props.selectedUiState === CommunicationsUIState.RecallsCreate;

        const messageMainUnderlined = (
            this.props.selectedUiState === CommunicationsUIState.MessagesCreate
            || this.props.selectedUiState === CommunicationsUIState.MessagesSearch
            || this.props.selectedUiState === CommunicationsUIState.MessagesView
        ) && (
            !this.props.selectedInbox
            || this.props.selectedInbox === CommunicationsUIStateInbox.Inbox
        );

        const messageSentUnderlined =
            this.props.selectedUiState === CommunicationsUIState.MessagesSearch
            && this.props.selectedInbox === CommunicationsUIStateInbox.Sent;

        const messageDraftUnderlined =
            this.props.selectedUiState === CommunicationsUIState.MessagesSearch
            && this.props.selectedInbox === CommunicationsUIStateInbox.Drafts;

        const messageArchiveUnderlined =
            this.props.selectedUiState === CommunicationsUIState.MessagesSearch
            && this.props.selectedInbox === CommunicationsUIStateInbox.Archive;

        const messageDeleteUnderlined =
            this.props.selectedUiState === CommunicationsUIState.MessagesSearch
            && this.props.selectedInbox === CommunicationsUIStateInbox.Trash;

        const taskMainUnderlined = (
            this.props.selectedUiState === CommunicationsUIState.TasksCreate
            || this.props.selectedUiState === CommunicationsUIState.TasksSearch
            || this.props.selectedUiState === CommunicationsUIState.TasksView
        ) && (
            !this.props.selectedInbox
            || this.props.selectedInbox === CommunicationsUIStateInbox.Inbox
        );

        const taskSentUnderlined =
            this.props.selectedUiState === CommunicationsUIState.TasksSearch
            && this.props.selectedInbox === CommunicationsUIStateInbox.Sent;

        const taskDraftUnderlined =
            this.props.selectedUiState === CommunicationsUIState.TasksSearch
            && this.props.selectedInbox === CommunicationsUIStateInbox.Drafts;

        const taskArchiveUnderlined =
            this.props.selectedUiState === CommunicationsUIState.TasksSearch
            && this.props.selectedInbox === CommunicationsUIStateInbox.Archive;

        const taskDeleteUnderlined =
            this.props.selectedUiState === CommunicationsUIState.TasksSearch
            && this.props.selectedInbox === CommunicationsUIStateInbox.Trash;

        const externalCommunicationMainUnderlined =
            (this.props.selectedUiState === CommunicationsUIState.ExternalCommunicationInbox
                && this.props.selectedInbox === CommunicationsUIStateInbox.Inbox)
            ||
            (this.props.selectedUiState === CommunicationsUIState.ExternalCommunicationCreate);

        const externalCommunicationSentUnderlined =
            this.props.selectedUiState === CommunicationsUIState.ExternalCommunicationOutbox
            && this.props.selectedInbox == CommunicationsUIStateInbox.Sent;

        const externalCommunicationDeleteUnderlined =
            this.props.selectedUiState === CommunicationsUIState.ExternalCommunicationInbox
            && this.props.selectedInbox == CommunicationsUIStateInbox.Trash;

        const shouldUnderlinePortalCommunicationInbox =
            this.props.selectedUiState === CommunicationsUIState.PortalCommunicationInbox
            && this.props.selectedInbox === CommunicationsUIStateInbox.Inbox;

        const shouldUnderlinePortalCommunicationSent =
            this.props.selectedUiState === CommunicationsUIState.PortalCommunicationInbox
            && this.props.selectedInbox === CommunicationsUIStateInbox.Sent;

        const shouldUnderlinePortalCommunicationArchive =
            this.props.selectedUiState === CommunicationsUIState.PortalCommunicationInbox
            && this.props.selectedInbox === CommunicationsUIStateInbox.Archive;

        const shouldUnderlinePortalCommunicationFlaggedForReview =
            this.props.selectedUiState === CommunicationsUIState.PortalCommunicationInbox
            && this.props.selectedInbox === CommunicationsUIStateInbox.FlaggedForReview;

        return (
            <div onClick={e => this.stopPropagation(e)}>
                <ul className="accordion" data-accordion="" data-cy="communicationsTreeControl-accordionMenu">

                    <li className="accordion-navigation clearfix">
                        <div className="displaced-nav-btns" data-cy="communicationsTreeControl-recall">
                            <a onClick={() => this.props.recallCreateClick()} className="plus_icon pull-left">&nbsp; </a>
                            <div className="pull-left">
                                <div>
                                    <a style={recallUnderlined ? { textDecoration: "underline" } : {}} className="bold" onClick={() => this.props.recallSearchClick()}>
                                        {cacheStore.GetString("RecallsLabel")} ({this.props.recallsCount})
                                    </a>
                                </div>
                            </div>
                        </div>
                    </li>

                    <li className="accordion-navigation clearfix">
                        <div className="displaced-nav-btns" data-cy="communicationsTreeControl-message">
                            <a onClick={() => this.props.messageCreateClick()} className="plus_icon pull-left">&nbsp; </a>
                            <div className="pull-left">
                                <div>
                                    <a
                                        className="bold"
                                        onClick={() => this.props.messageSearchClick(CommunicationsUIStateInbox.Inbox)}
                                        style={messageMainUnderlined ? { textDecoration: "underline" } : {}}
                                    >
                                        {cacheStore.GetString("MessagesLabel")} ({this.props.messagesCount})
                                    </a>
                                </div>
                                <div>
                                    <a
                                        className="displaced"
                                        data-cy="communicationsTreeControl-message-sent"
                                        onClick={() => this.props.messageSearchClick(CommunicationsUIStateInbox.Sent)}
                                        style={messageSentUnderlined ? { textDecoration: "underline" } : {}}
                                    >
                                        {cacheStore.GetString("SentLabel")}
                                    </a>
                                </div>
                                <div>
                                    <a
                                        className="displaced"
                                        onClick={() => this.props.messageSearchClick(CommunicationsUIStateInbox.Drafts)}
                                        style={messageDraftUnderlined ? { textDecoration: "underline" } : {}}
                                    >
                                        {cacheStore.GetString("DraftsLabel")}
                                    </a>
                                </div>
                                <div>
                                    <a
                                        className="displaced"
                                        onClick={() => this.props.messageSearchClick(CommunicationsUIStateInbox.Archive)}
                                        style={messageArchiveUnderlined ? { textDecoration: "underline" } : {}}
                                    >
                                        {cacheStore.GetString("ArchiveLabel")}
                                    </a>
                                </div>
                                <div>
                                    <a
                                        className="displaced"
                                        onClick={() => this.props.messageSearchClick(CommunicationsUIStateInbox.Trash)}
                                        style={messageDeleteUnderlined ? { textDecoration: "underline" } : {}}
                                    >
                                        {cacheStore.GetString("TrashLabel")}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </li>

                    <li className="accordion-navigation clearfix">
                        <div className="displaced-nav-btns" data-cy="communicationsTreeControl-task">
                            <a onClick={() => this.props.taskCreateClick()} className="plus_icon pull-left">&nbsp;</a>
                            <div className="pull-left">
                                <div>
                                    <a
                                        style={taskMainUnderlined ? { textDecoration: "underline" } : {}}
                                        className="bold"
                                        onClick={() => this.props.taskSearchClick(CommunicationsUIStateInbox.Inbox)}
                                    >
                                        {cacheStore.GetString("TasksLabel")} ({this.props.tasksCount})
                                    </a>
                                </div>
                                <div>
                                    <a
                                        style={taskSentUnderlined ? { textDecoration: "underline" } : {}}
                                        className="displaced"
                                        data-cy="communication-task-sent"
                                        onClick={() => this.props.taskSearchClick(CommunicationsUIStateInbox.Sent)}
                                    >
                                        {cacheStore.GetString("SentFLabel")}
                                    </a>
                                </div>
                                <div>
                                    <a
                                        className="displaced"
                                        data-cy="communication-task-drafts"
                                        onClick={() => this.props.taskSearchClick(CommunicationsUIStateInbox.Drafts)}
                                        style={taskDraftUnderlined ? { textDecoration: "underline" } : {}}
                                    >
                                        {cacheStore.GetString("DraftsLabel")}
                                    </a>
                                </div>
                                <div>
                                    <a
                                        className="displaced"
                                        onClick={() => this.props.taskSearchClick(CommunicationsUIStateInbox.Archive)}
                                        style={taskArchiveUnderlined ? { textDecoration: "underline" } : {}}
                                    >
                                        {cacheStore.GetString("ArchivedTasksLabel")}
                                    </a>
                                </div>
                                <div>
                                    <a
                                        className="displaced"
                                        onClick={() => this.props.taskSearchClick(CommunicationsUIStateInbox.Trash)}
                                        style={taskDeleteUnderlined ? { textDecoration: "underline" } : {}}
                                    >
                                        {cacheStore.GetString("TrashLabel")}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </li>

                    {cacheStore.ClinicSettings.EnableExternalCommunication && (
                        <li className="accordion-navigation clearfix">
                            <div className="displaced-nav-btns">
                                <a onClick={() => this.props.externalCommunicationCreateClick()} className="plus_icon pull-left">&nbsp;</a>
                                <div className="pull-left">
                                    <div>
                                        <a
                                            style={externalCommunicationMainUnderlined ? { textDecoration: "underline" } : {}}
                                            className="bold"
                                            onClick={() => this.props.externalCommunicationSearchClick(CommunicationsUIStateInbox.Inbox)}
                                        >
                                            {cacheStore.GetString("ExternalCommunicationsLabel")} ({this.props.externalMessagesCount || 0})
                                        </a>
                                    </div>
                                    <div>
                                        <a
                                            style={externalCommunicationSentUnderlined ? { textDecoration: "underline" } : {}}
                                            className="displaced"
                                            onClick={() => this.props.externalCommunicationSearchClick(CommunicationsUIStateInbox.Sent)}
                                        >
                                            {cacheStore.GetString("SentFLabel")}
                                        </a>
                                    </div>
                                    <div>
                                        <a
                                            style={externalCommunicationDeleteUnderlined ? { textDecoration: "underline" } : {}}
                                            className="displaced"
                                            onClick={() => this.props.externalCommunicationSearchClick(CommunicationsUIStateInbox.Trash)}
                                        >
                                            {cacheStore.GetString("TrashLabel")}
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </li>
                    )}

                    {cacheStore.ClinicSettings.EnableBidirectionalCommunication && (
                        <li className="accordion-navigation clearfix">
                            <div className="displaced-nav-btns">
                                <a onClick={() => this.props.portalCommunicationCreateClick()} className="plus_icon pull-left">&nbsp;</a>
                                <div className="pull-left">
                                    <div>
                                        <HyperLinkControl
                                            text={`${cacheStore.GetString("SharedItem_PortalCommunicationsLabel")} (${this.props.portalCommunicationsUnreadCount ?? 0})`}
                                            className="bold"
                                            dataCy="communications-treeControl-portal-communications"
                                            onChange={() => this.props.portalCommunicationSearchClick(CommunicationsUIStateInbox.Inbox)}
                                            IsUnderLined={shouldUnderlinePortalCommunicationInbox}
                                            shouldOmitMargin
                                        />
                                    </div>
                                    <div>
                                        <HyperLinkControl
                                            text={`${cacheStore.GetString(CommunicationsHelper.getLabelByCommunicationsUIStateInbox(CommunicationsUIStateInbox.FlaggedForReview))} (${this.props.portalCommunicationsFlaggedCount ?? 0})`}
                                            className="displaced"
                                            dataCy="portal-communications-flagged-for-review"
                                            onChange={() => this.props.portalCommunicationSearchClick(CommunicationsUIStateInbox.FlaggedForReview)}
                                            IsUnderLined={shouldUnderlinePortalCommunicationFlaggedForReview}
                                            shouldOmitMargin
                                        />
                                    </div>
                                    <div>
                                        <HyperLinkControl
                                            text={cacheStore.GetString(CommunicationsHelper.getLabelByCommunicationsUIStateInbox(CommunicationsUIStateInbox.Sent))}
                                            className="displaced"
                                            onChange={() => this.props.portalCommunicationSearchClick(CommunicationsUIStateInbox.Sent)}
                                            IsUnderLined={shouldUnderlinePortalCommunicationSent}
                                            shouldOmitMargin
                                        />
                                    </div>
                                    <div>
                                        <HyperLinkControl
                                            text={cacheStore.GetString(CommunicationsHelper.getLabelByCommunicationsUIStateInbox(CommunicationsUIStateInbox.Archive))}
                                            className="displaced"
                                            onChange={() => this.props.portalCommunicationSearchClick(CommunicationsUIStateInbox.Archive)}
                                            IsUnderLined={shouldUnderlinePortalCommunicationArchive}
                                            shouldOmitMargin
                                        />
                                    </div>
                                </div>
                            </div>
                        </li>
                    )}
                </ul>
            </div>
        );
    }

    private stopPropagation(e: React.MouseEvent): void {
        e.stopPropagation();
    }
}

export { CommunicationsTreeControl_OptimizedV2 };
